import { render, staticRenderFns } from "./GlobalLoadingDialog.vue?vue&type=template&id=48c94986&scoped=true&"
import script from "./GlobalLoadingDialog.vue?vue&type=script&lang=js&"
export * from "./GlobalLoadingDialog.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLoadingDialog.vue?vue&type=style&index=0&id=48c94986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c94986",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VDialog,VProgressLinear})
